import { Button, Link } from "@mui/material";
import { FC, useContext } from "react";
import { useFormContext } from "react-hook-form";
import { useSetRecoilState } from "recoil";

import { EmailInputByControl } from "@ryde/controls";
import { useAuthActions } from "@ryde/redux";
import { Log, loginFlowStepAtom, LoginFormFlow } from "@ryde/shared";

import { LoginPageFormContext } from "../login.page.form.context";
import { textboxLoginSx } from "../login.page.styled";
import { useLoginTranslation } from "../use-login-translation";
import { getButtonLoginSx } from "./login.parts.styled";

export const LoginForgotPasswordForm: FC = () => {
  const { handleForgotPassword, setLoginErrors } = useAuthActions();
  const {
    control,
    getValues,
    trigger,
    formState: { errors },
  } = useFormContext();
  const { t } = useLoginTranslation();
  const setLoginFlowStepAtom = useSetRecoilState(loginFlowStepAtom);
  const { isNonProductionLoginColors } = useContext(LoginPageFormContext);

  const handleForgotPasswordClick = (): void => {
    trigger()
      .then(() => {
        if (!errors.Email) {
          const { Email } = getValues();

          if (Email) {
            handleForgotPassword(Email);
          }
        }
      })
      .catch(err => {
        const errorName = t("errors.LOGIN_ERROR");
        Log.error(errorName, err);
        setLoginErrors([`${errorName}: ${(err as Error)?.message}`]);
      });
  };

  const onBackClick = (): void => {
    setLoginFlowStepAtom(LoginFormFlow.GENERIC_STEP);
  };

  return (
    <div className="LoginGenericForm">
      <div className="LoginGenericForm-FieldContainer">
        <div className="LoginGenericForm-LabelSignIn">
          {t("login.ENTER_YOUR_EMAIL")}
        </div>
        <EmailInputByControl
          control={control}
          name="Email"
          sx={textboxLoginSx}
          size="small"
        />
      </div>
      <Button
        data-e2e="button-login-saml"
        variant="contained"
        color={isNonProductionLoginColors ? "inherit" : "primary"}
        sx={getButtonLoginSx(isNonProductionLoginColors)}
        onClick={handleForgotPasswordClick}
      >
        {t("login.SEND_PASSWORD_RESET_LINK")}
      </Button>
      <Link style={{ cursor: "pointer" }} onClick={onBackClick}>
        ← {t("login.BACK")}
      </Link>
    </div>
  );
};
